import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pc-spinning-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinning-loader.component.html',
  styleUrls: ['./spinning-loader.component.scss']
})
export class SpinningLoaderComponent {
  @Input() isPrimaryColor = false;
  @Input() isLarge = false;
  @Input() largeBgColor = LoaderBgColor.PRIMARY_LIGHT;
}

export enum LoaderBgColor {
  PRIMARY_LIGHT = 'primary-light',
  PRIMARY = 'primary'
}
